/**
 * 25种动物原型定义
 * 每个动物包含：向量（7维度得分）、描述、特征、职业建议、相性等信息
 */
export const animalArchetypes = {
  "狗": {
    emoji: "🐶",
    vector: {
      DOM: 1,
      STR: 1,
      COM: 5,
      SOL: 0,
      AGI: 3,
      SEC: 4,
      AES: 1
    },
    name: "狗 - 忠诚伙伴",
    description: `你是忠诚的伙伴与热情的守护者。你的世界围绕着"我们"展开，无论是家人、朋友还是团队。你擅长建立连接，给予温暖，并在群体中找到自己的价值。你的快乐简单而纯粹，来源于陪伴与被需要。`,
    traits: [
      "高度社群性，依赖团队",
      "强烈的安全感需求",
      "忠诚且热情",
      "享受陪伴他人"
    ],
    careers: ["教师", "护士", "客服", "社工"],
    compatibility: {
      best: ["水豚", "鹦鹉", "海豚", "草泥马"],
      good: ["狼", "鲸", "猪"],
      challenging: ["猫", "鲨鱼", "鹰", "蚊子"]
    },
    color: "#f59e0b",
    tags: ["社交型", "忠诚", "团队"]
  },
  
  "猫": {
    emoji: "🐱",
    vector: {
      DOM: 1,
      STR: 2,
      COM: 0,
      SOL: 5,
      AGI: 4,
      SEC: 2,
      AES: 3
    },
    name: "猫 - 优雅独行者",
    description: "你是优雅的独立思想家，神秘且自我满足。你享受独处，拥有丰富的内心世界。你行动敏捷，好奇心强，但只对自己感兴趣的事物投入精力。你的魅力在于那份若即若离的疏离感和无法预测的灵动。",
    traits: [
      "高度独立，享受独处",
      "敏捷灵活，适应力强",
      "有美学追求",
      "神秘且难以捉摸"
    ],
    careers: ["作家", "设计师", "程序员", "艺术家"],
    compatibility: {
      best: ["狐", "章鱼", "鹰", "猪", "蝴蝶"],
      good: ["鹿", "天鹅", "蚊子"],
      challenging: ["狗", "水豚", "猫鼬"]
    },
    color: "#8b5cf6",
    tags: ["独立型", "敏捷", "美学"]
  },
  
  "狼": {
    emoji: "🐺",
    vector: {
      DOM: 4,
      STR: 4,
      COM: 3,
      SOL: 2,
      AGI: 2,
      SEC: 1,
      AES: 0
    },
    name: "狼 - 战略领袖",
    description: "你是天生的领袖与战略家，兼具力量与社群智慧。你既能独立思考，又能无缝地融入团队。你对目标执着，有强烈的责任感和领地意识，为了守护族群，你会展现出惊人的统御力和谋略。",
    traits: [
      "天生的领导者",
      "兼具个人能力与团队精神",
      "战略思维强",
      "保护欲强"
    ],
    careers: ["项目经理", "创业者", "军事指挥官", "团队领导"],
    compatibility: {
      best: ["狗", "海豚", "猫鼬"],
      good: ["乌鸦", "鲸"],
      challenging: ["猫", "鲨鱼", "猪"]
    },
    color: "#4b5563",
    tags: ["领导型", "战略", "团队"]
  },
  
  "狐": {
    emoji: "🦊",
    vector: {
      DOM: 1,
      STR: 5,
      COM: 0,
      SOL: 4,
      AGI: 4,
      SEC: 1,
      AES: 1
    },
    name: "狐 - 机敏策略家",
    description: `你是机敏的策略家与孤独的观察者。你拥有超凡的智慧和适应能力，擅长在复杂的环境中找到最优解。你倾向于独立行动，用敏锐的洞察力规避风险，达成目标。你的生存哲学是"智取"而非"强攻"。`,
    traits: [
      "极高的智商和策略能力",
      "独立且适应力强",
      "敏锐的洞察力",
      "善于规避风险"
    ],
    careers: ["战略顾问", "分析师", "侦探", "研究员"],
    compatibility: {
      best: ["猫", "章鱼", "乌鸦", "蚊子"],
      good: ["鹰", "浣熊", "蟑螂"],
      challenging: ["狗", "水豚", "草泥马"]
    },
    color: "#f97316",
    tags: ["策略型", "智慧", "独立"]
  },
  
  "狮": {
    emoji: "🦁",
    vector: {
      DOM: 5,
      STR: 2,
      COM: 3,
      SOL: 3,
      AGI: 1,
      SEC: 2,
      AES: 2
    },
    name: "狮 - 自信王者",
    description: "你是自信的王者，天生自带光环。你有强烈的统御欲和表现力，享受成为焦点的感觉。你慷慨、富有魅力，但有时也需要独处的空间来积蓄力量。你的存在本身就是一种宣告，充满力量与威严。",
    traits: [
      "强大的统御力",
      "自信且有魅力",
      "享受成为焦点",
      "慷慨大方"
    ],
    careers: ["CEO", "演说家", "政治家", "企业家"],
    compatibility: {
      best: ["狼", "鹰", "鲨鱼"],
      good: ["海豚", "乌鸦"],
      challenging: ["猫", "狐", "蟑螂"]
    },
    color: "#eab308",
    tags: ["领袖型", "自信", "魅力"]
  },
  
  "熊": {
    emoji: "🐻",
    vector: {
      DOM: 3,
      STR: 1,
      COM: 1,
      SOL: 4,
      AGI: 0,
      SEC: 5,
      AES: 1
    },
    name: "熊 - 沉稳守护者",
    description: "你是沉稳的守护者，强大而内敛。你大部分时间安静、平和，享受自己的节奏，但当领地或家人受到威胁时，会爆发出无与伦比的力量。你重视安全感，喜欢为自己和亲近的人建立一个舒适、安全的庇护所。",
    traits: [
      "沉稳强大",
      "极高的安全感需求",
      "保护欲强",
      "享受独处和平静"
    ],
    careers: ["保安专家", "家庭主妇/夫", "建筑师", "隐士"],
    compatibility: {
      best: ["兔", "仓鼠", "鹿", "蟑螂"],
      good: ["狗", "猫鼬"],
      challenging: ["鲨鱼", "狮", "蝴蝶"]
    },
    color: "#92400e",
    tags: ["安全型", "守护", "沉稳"]
  },
  
  "兔": {
    emoji: "🐰",
    vector: {
      DOM: 0,
      STR: 1,
      COM: 2,
      SOL: 2,
      AGI: 5,
      SEC: 5,
      AES: 2
    },
    name: "兔 - 警觉和平者",
    description: "你是警觉的和平主义者，敏捷且富有同情心。你极度需要安全感，对环境变化非常敏感。你行动迅速，擅长躲避冲突。虽然有时会显得胆小，但你在熟悉和安全的小圈子里，会展现出活泼、温和的一面。",
    traits: [
      "高度敏感和警觉",
      "敏捷灵活",
      "和平主义者",
      "在安全环境中活泼"
    ],
    careers: ["图书管理员", "会计", "数据分析", "翻译"],
    compatibility: {
      best: ["熊", "鹿", "水豚", "蟑螂"],
      good: ["狗", "仓鼠"],
      challenging: ["鲨鱼", "鹰", "狼"]
    },
    color: "#fbbf24",
    tags: ["敏感型", "敏捷", "和平"]
  },
  
  "仓鼠": {
    emoji: "🐹",
    vector: {
      DOM: 0,
      STR: 0,
      COM: 2,
      SOL: 4,
      AGI: 1,
      SEC: 5,
      AES: 1
    },
    name: "仓鼠 - 安逸囤积者",
    description: `你是专注的囤积者与安逸的生活家。你最大的幸福来自于建立一个充满安全感的"小窝"。你喜欢收集和整理，无论是物质还是信息。你享受在自己的小世界里自得其乐，对外界的纷扰保持着一种可爱的迟钝。`,
    traits: [
      "喜欢囤积和整理",
      "安全感需求极高",
      "享受小世界",
      "对外界保持距离"
    ],
    careers: ["收藏家", "档案管理员", "居家工作者", "整理师"],
    compatibility: {
      best: ["熊", "兔", "鹿", "蟑螂", "猪"],
      good: ["猫", "水豚"],
      challenging: ["鲨鱼", "鹰", "蝴蝶"]
    },
    color: "#a3e635",
    tags: ["安逸型", "囤积", "居家"]
  },
  
  "天鹅": {
    emoji: "🦢",
    vector: {
      DOM: 2,
      STR: 1,
      COM: 2,
      SOL: 3,
      AGI: 1,
      SEC: 2,
      AES: 5
    },
    name: "天鹅 - 优雅理想主义者",
    description: "你是优雅的理想主义者，对美有着极致的追求。你姿态高贵，带有一种天生的距离感，但内心深处对伴侣和家庭极为忠诚。你的世界里，精神的契合与外在的和谐同样重要，绝不容忍粗俗与将就。",
    traits: [
      "对美有极致追求",
      "优雅高贵",
      "理想主义者",
      "忠诚但有距离感"
    ],
    careers: ["艺术家", "设计师", "时尚编辑", "美学顾问"],
    compatibility: {
      best: ["鹿", "猫", "鲸", "蝴蝶"],
      good: ["天鹅", "鹦鹉"],
      challenging: ["水豚", "狗", "蟑螂"]
    },
    color: "#f0abfc",
    tags: ["美学型", "优雅", "理想"]
  },
  
  "鹿": {
    emoji: "🦌",
    vector: {
      DOM: 1,
      STR: 1,
      COM: 3,
      SOL: 3,
      AGI: 3,
      SEC: 4,
      AES: 4
    },
    name: "鹿 - 温和自然之子",
    description: "你是温和的自然之子，敏感而优雅。你对美和宁静有着天生的向往，常常沉浸在自己的精神世界里。你警惕性高，需要安全的环境才能放松。你的美在于那份不染尘埃的纯净和与自然融为一体的灵性。",
    traits: [
      "温和敏感",
      "对美和宁静的向往",
      "警惕性高",
      "灵性和纯净"
    ],
    careers: ["环保工作者", "治疗师", "瑜伽教练", "园艺师"],
    compatibility: {
      best: ["兔", "天鹅", "熊", "草泥马", "蝴蝶"],
      good: ["猫", "鲸", "猪"],
      challenging: ["鲨鱼", "狼"]
    },
    color: "#a78bfa",
    tags: ["温和型", "美学", "灵性"]
  },
  
  "鹰": {
    emoji: "🦅",
    vector: {
      DOM: 4,
      STR: 3,
      COM: 0,
      SOL: 5,
      AGI: 2,
      SEC: 1,
      AES: 2
    },
    name: "鹰 - 高傲远见者",
    description: "你是高傲的远见者，拥有无与伦比的视野和决心。你习惯于从高处审视全局，制定长远的目标。你享受孤独，因为那能让你看得更清。你的力量不仅在于捕猎的利爪，更在于那份凌驾于一切之上的独立意志和宏大格局。",
    traits: [
      "宏大格局和远见",
      "高度独立",
      "决心坚定",
      "享受孤独"
    ],
    careers: ["战略规划师", "投资家", "高级顾问", "哲学家"],
    compatibility: {
      best: ["猫", "狐", "章鱼"],
      good: ["狮", "鲨鱼", "蚊子"],
      challenging: ["狗", "水豚", "鹦鹉", "草泥马", "猪"]
    },
    color: "#0891b2",
    tags: ["远见型", "独立", "格局"]
  },
  
  "乌鸦": {
    emoji: "🐦‍⬛",
    vector: {
      DOM: 2,
      STR: 5,
      COM: 4,
      SOL: 2,
      AGI: 3,
      SEC: 1,
      AES: 0
    },
    name: "乌鸦 - 智慧谜题解决者",
    description: "你是聪慧的谜题解决者与信息的传递者。你拥有极高的智商和好奇心，善于观察、学习和使用工具。你具有复杂的社会结构，擅长合作与沟通。在别人看来，你或许有些神秘甚至不祥，但这正是你智慧的保护色。",
    traits: [
      "极高智商",
      "善于观察和学习",
      "复杂的社交能力",
      "神秘智慧"
    ],
    careers: ["科学家", "发明家", "侦探", "密码学家"],
    compatibility: {
      best: ["狐", "章鱼", "海豚"],
      good: ["狼", "浣熊", "蚊子"],
      challenging: ["仓鼠", "兔"]
    },
    color: "#1e293b",
    tags: ["智慧型", "策略", "社交"]
  },
  
  "水豚": {
    emoji: "🦫",
    vector: {
      DOM: 0,
      STR: 0,
      COM: 5,
      SOL: 2,
      AGI: 1,
      SEC: 5,
      AES: 2
    },
    name: "水豚 - 随和社交大师",
    description: `你是随和的社交大师，情绪稳定，万物皆可为友。你的存在本身就能给周围带来平静与和谐。你享受社群生活，但从不强求，用一种"佛系"的态度接纳一切。你的哲学是：放轻松，没什么大不了的。`,
    traits: [
      "极度随和",
      "情绪稳定",
      "社交能力强",
      "佛系态度"
    ],
    careers: ["调解员", "客服", "心理咨询师", "社区工作者"],
    compatibility: {
      best: ["狗", "鹦鹉", "猫鼬", "草泥马", "猪"],
      good: ["海豚", "鲸"],
      challenging: ["猫", "鹰", "鲨鱼", "蚊子"]
    },
    color: "#84cc16",
    tags: ["和平型", "社交", "佛系"]
  },
  
  "鲸": {
    emoji: "🐋",
    vector: {
      DOM: 2,
      STR: 3,
      COM: 4,
      SOL: 4,
      AGI: 0,
      SEC: 2,
      AES: 4
    },
    name: "鲸 - 深海哲学家",
    description: "你是深海的哲学家，古老而智慧。你承载着厚重的记忆，用深沉的歌声在广阔的社群中交流。你既能融入庞大的集体，又保持着个体的深邃孤独。你的内心像海洋一样，平静时包容万物，翻涌时充满力量。",
    traits: [
      "深邃的智慧",
      "兼具社群性和独处性",
      "包容性强",
      "情感深沉"
    ],
    careers: ["哲学家", "作家", "历史学家", "精神导师"],
    compatibility: {
      best: ["海豚", "天鹅", "鹿"],
      good: ["狼", "猫", "草泥马", "猪", "蝴蝶"],
      challenging: ["鲨鱼", "兔"]
    },
    color: "#0ea5e9",
    tags: ["哲学型", "智慧", "包容"]
  },
  
  "鹦鹉": {
    emoji: "🦜",
    vector: {
      DOM: 1,
      STR: 2,
      COM: 5,
      SOL: 1,
      AGI: 5,
      SEC: 1,
      AES: 2
    },
    name: "鹦鹉 - 聪明社交达人",
    description: `你是聪明的社交达人与天生的表演家。你热爱互动，擅长模仿和学习，是群体中的"开心果"和信息中心。你活泼好动，充满好奇心，总能给平淡的生活增添色彩和戏剧性。你的智慧体现在与他人的互动和交流中。`,
    traits: [
      "社交能力极强",
      "活泼好动",
      "学习能力强",
      "是群体的开心果"
    ],
    careers: ["主持人", "销售", "公关", "演员"],
    compatibility: {
      best: ["狗", "水豚", "海豚"],
      good: ["猫鼬", "乌鸦", "蝴蝶"],
      challenging: ["猫", "鹰"]
    },
    color: "#22c55e",
    tags: ["社交型", "活泼", "表演"]
  },
  
  "章鱼": {
    emoji: "🐙",
    vector: {
      DOM: 2,
      STR: 5,
      COM: 0,
      SOL: 5,
      AGI: 4,
      SEC: 1,
      AES: 1
    },
    name: "章鱼 - 深海智者",
    description: `你是深海的智者与伪装大师。你拥有惊人的智慧和解决问题的能力，身体的每一次变形都是一次策略的展现。你习惯于独立思考和行动，在复杂环境中展现出极强的适应性和创造力。你是真正的"多面手"。`,
    traits: [
      "惊人的智慧",
      "适应能力极强",
      "独立且多才多艺",
      "善于伪装和策略"
    ],
    careers: ["多领域专家", "创新者", "独立研究员", "黑客"],
    compatibility: {
      best: ["狐", "猫", "鹰", "蚊子"],
      good: ["乌鸦", "浣熊"],
      challenging: ["狗", "水豚"]
    },
    color: "#7c3aed",
    tags: ["智慧型", "独立", "多才"]
  },
  
  "鲨鱼": {
    emoji: "🦈",
    vector: {
      DOM: 5,
      STR: 3,
      COM: 0,
      SOL: 5,
      AGI: 3,
      SEC: 0,
      AES: 0
    },
    name: "鲨鱼 - 高效追逐者",
    description: "你是高效的目标追逐者，专注、直接、充满力量。你一旦锁定目标，便会心无旁骛地前进。你习惯独来独往，不需要复杂的社交关系。你的生存法则简单而纯粹：不断前进，永不停止。",
    traits: [
      "目标导向极强",
      "专注且高效",
      "独立行动",
      "永不停止"
    ],
    careers: ["运动员", "销售精英", "猎头", "创业者"],
    compatibility: {
      best: ["鹰", "狮", "狼"],
      good: ["章鱼", "浣熊"],
      challenging: ["狗", "水豚", "兔", "猫鼬", "蟑螂", "草泥马", "猪"]
    },
    color: "#475569",
    tags: ["目标型", "高效", "独立"]
  },
  
  "海豚": {
    emoji: "🐬",
    vector: {
      DOM: 3,
      STR: 4,
      COM: 5,
      SOL: 0,
      AGI: 4,
      SEC: 1,
      AES: 1
    },
    name: "海豚 - 智慧嬉戏者",
    description: "你是智慧的嬉戏者与团队合作的典范。你拥有高度发达的大脑和复杂的社会行为，擅长通过合作解决问题。你充满玩乐精神，将生活视为一场有趣的游戏。你的快乐来源于与同伴的协作和探索世界的无穷乐趣。",
    traits: [
      "高智商",
      "团队合作能力强",
      "充满玩乐精神",
      "社交能力强"
    ],
    careers: ["教练", "团队培训师", "游戏设计师", "娱乐策划"],
    compatibility: {
      best: ["狗", "鹦鹉", "狼"],
      good: ["水豚", "鲸", "猫鼬", "草泥马", "蝴蝶"],
      challenging: ["猫", "鹰"]
    },
    color: "#06b6d4",
    tags: ["智慧型", "团队", "玩乐"]
  },
  
  "浣熊": {
    emoji: "🦝",
    vector: {
      DOM: 1,
      STR: 4,
      COM: 2,
      SOL: 3,
      AGI: 5,
      SEC: 2,
      AES: 0
    },
    name: "浣熊 - 机灵探险家",
    description: `你是机灵的都市探险家，总能找到解决问题的"歪路子"。你好奇心极强，动手能力超群，为了达成目的可以不择手段（通常是为了吃的）。你非常灵活，总能在人类制定的规则中找到自己的生存空间。`,
    traits: [
      "好奇心极强",
      "动手能力强",
      "灵活变通",
      "善于找捷径"
    ],
    careers: ["自由职业者", "修理工", "生存专家", "探险家"],
    compatibility: {
      best: ["狐", "章鱼", "乌鸦", "蚊子"],
      good: ["浣熊", "鹦鹉", "蟑螂"],
      challenging: ["熊", "狮"]
    },
    color: "#64748b",
    tags: ["灵活型", "探险", "好奇"]
  },
  
  "猫鼬": {
    emoji: "🦨",
    vector: {
      DOM: 2,
      STR: 3,
      COM: 5,
      SOL: 1,
      AGI: 3,
      SEC: 5,
      AES: 0
    },
    name: "猫鼬 - 警惕哨兵",
    description: "你是警惕的哨兵与家庭的守护者。你对集体有着极强的归属感和责任心，时刻为家人的安全站岗放哨。你们的生存依赖于高效的团队协作和分工。你的勇敢不是为了个人，而是为了整个族群的安危。",
    traits: [
      "强烈的集体归属感",
      "警惕性极高",
      "团队协作能力强",
      "保护家人"
    ],
    careers: ["安保人员", "护士", "消防员", "家庭守护者"],
    compatibility: {
      best: ["狗", "水豚", "狼"],
      good: ["鹦鹉", "海豚", "蟑螂", "草泥马"],
      challenging: ["猫", "鹰", "鲨鱼", "蚊子"]
    },
    color: "#f59e0b",
    tags: ["守护型", "团队", "警惕"]
  },
  
  "蟑螂": {
    emoji: "🪳",
    vector: {
      DOM: 0,
      STR: 4,
      COM: 2,
      SOL: 4,
      AGI: 5,
      SEC: 5,
      AES: 0
    },
    name: "蟑螂 - 顽强生存者",
    description: "你是顽强的生存者，拥有令人惊叹的适应能力和生命力。你低调务实，不追求华丽的外表，而是将所有精力投入到生存和适应中。你极度重视安全感，善于在任何环境中找到生存之道。你的哲学是：活下去，比什么都重要。",
    traits: [
      "极强的生存能力",
      "高度适应性",
      "务实低调",
      "安全感需求极高"
    ],
    careers: ["危机管理", "应急响应", "生存训练师", "风险评估师"],
    compatibility: {
      best: ["仓鼠", "熊", "兔"],
      good: ["狐", "浣熊", "猫鼬"],
      challenging: ["狮", "鲨鱼", "天鹅"]
    },
    color: "#78716c",
    tags: ["生存型", "适应", "务实"]
  },
  
  "草泥马": {
    emoji: "🦙",
    vector: {
      DOM: 1,
      STR: 2,
      COM: 4,
      SOL: 1,
      AGI: 2,
      SEC: 4,
      AES: 3
    },
    name: "草泥马 - 温柔有底线",
    description: "你是温和但有原则的和平主义者。你喜欢群体生活，享受与他人的陪伴，性格随和友善。但当你的底线被触碰时，你会毫不犹豫地表达不满。你的生活节奏悠闲，追求稳定和谐，用可爱的外表掩盖着坚定的内心。",
    traits: [
      "温和友善",
      "有明确底线",
      "社群性强",
      "慢节奏生活"
    ],
    careers: ["客户服务", "团队协作", "教育工作", "社区管理"],
    compatibility: {
      best: ["狗", "水豚", "鹿"],
      good: ["猫鼬", "海豚", "鲸"],
      challenging: ["鲨鱼", "鹰", "狐"]
    },
    color: "#d97706",
    tags: ["温和型", "团队", "可爱"]
  },
  
  "猪": {
    emoji: "🐷",
    vector: {
      DOM: 0,
      STR: 3,
      COM: 4,
      SOL: 1,
      AGI: 1,
      SEC: 4,
      AES: 2
    },
    name: "猪 - 聪明享乐主义者",
    description: "你是聪明的享乐主义者，懂得生活的真谛在于享受当下。你比外表看起来聪明得多，善于用最少的努力获得最大的舒适。你热爱美食、舒适和温暖，不喜欢无谓的竞争。你的人生哲学是：快乐比成功更重要。",
    traits: [
      "实际上很聪明",
      "享受生活",
      "社交能力强",
      "乐观随和"
    ],
    careers: ["美食评论", "生活顾问", "理财规划", "人力资源"],
    compatibility: {
      best: ["水豚", "猫", "仓鼠"],
      good: ["狗", "鹿", "鲸"],
      challenging: ["鲨鱼", "狼", "鹰"]
    },
    color: "#ec4899",
    tags: ["享乐型", "聪明", "乐观"]
  },
  
  "蚊子": {
    emoji: "🦟",
    vector: {
      DOM: 0,
      STR: 4,
      COM: 0,
      SOL: 5,
      AGI: 5,
      SEC: 2,
      AES: 0
    },
    name: "蚊子 - 机敏机会主义者",
    description: "你是敏锐的机会主义者，拥有极高的敏捷性和观察力。你善于在复杂环境中找到机会，独立行动，避免正面冲突。你的生存策略是速度和时机，而非力量。你可能不被所有人喜欢，但你的适应能力和灵活性无可置疑。",
    traits: [
      "极度敏锐",
      "机会主义者",
      "独立行动",
      "灵活多变"
    ],
    careers: ["市场分析", "机会投资", "自由职业", "侦查工作"],
    compatibility: {
      best: ["狐", "章鱼", "浣熊"],
      good: ["乌鸦", "猫", "鹰"],
      challenging: ["狗", "水豚", "猫鼬"]
    },
    color: "#525252",
    tags: ["机会型", "敏捷", "独立"]
  },
  
  "蝴蝶": {
    emoji: "🦋",
    vector: {
      DOM: 0,
      STR: 2,
      COM: 3,
      SOL: 2,
      AGI: 4,
      SEC: 1,
      AES: 5
    },
    name: "蝴蝶 - 自由美学家",
    description: "你是优雅的自由美学家，对美有着极致的追求。你灵动多变，如同舞蹈般穿梭在生活中。你追求精神的自由和视觉的美感，不喜欢被束缚。你的生命短暂而绚烂，你选择用最美的方式度过每一刻。",
    traits: [
      "极致美学追求",
      "自由灵动",
      "优雅多变",
      "不喜束缚"
    ],
    careers: ["艺术设计", "时尚顾问", "创意策划", "自由艺术家"],
    compatibility: {
      best: ["猫", "天鹅", "鹿"],
      good: ["鹦鹉", "海豚", "鲸"],
      challenging: ["熊", "仓鼠", "蟑螂"]
    },
    color: "#c026d3",
    tags: ["美学型", "自由", "优雅"]
  }
};

/**
 * 获取所有动物名称列表
 * @returns {string[]} 动物名称数组
 */
export function getAllAnimalNames() {
  return Object.keys(animalArchetypes);
}

/**
 * 根据名称获取动物数据
 * @param {string} name - 动物名称
 * @returns {Object|null} 动物数据对象，不存在则返回null
 */
export function getAnimalByName(name) {
  return animalArchetypes[name] || null;
}

/**
 * 获取动物的emoji
 * @param {string} name - 动物名称
 * @returns {string} emoji字符
 */
export function getAnimalEmoji(name) {
  const animal = animalArchetypes[name];
  return animal ? animal.emoji : '🐾';
}

